import { HttpClient } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Observable } from 'rxjs';
import { SubscriptionDetailsSimplified } from '@shared/models/subscription-model';
import { Injectable, inject } from '@angular/core';
import { AssignedSubscriptionModel } from '@shared/models/assigned-subscription-offering.model';
import { VoiceAllowedChangeInfo } from '../modules/subscription/models/offerings-response.model';
import { MbbAllowedChangeInfo } from '../modules/mbb/models/mbb-offerings-response.model';
import { AdditionalServiceSet } from '../modules/subscription/models/additional-service-voice.model';
import { Subscriber } from '@shared/models/subscriber.model';
import { SubscriptionCosts } from '@shared/models/subscription-costs.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  getSubscriptionUser(subscriptionId: string): Observable<Subscriber> {
    const subscriptionUrl = this.apiUrl + `/subscription/${subscriptionId}/user`;
    return this.http.get<Subscriber>(subscriptionUrl);
  }

  getOfferingsForVoiceSubscription(subscriptionId: string): Observable<VoiceAllowedChangeInfo[]> {
    const offeringUrl = this.apiUrl + `/subscription/${subscriptionId}/offerings`;
    return this.http.get<VoiceAllowedChangeInfo[]>(offeringUrl);
  }

  getOfferingsForMbbSubscription(subscriptionId: string): Observable<MbbAllowedChangeInfo[]> {
    const offeringUrl = this.apiUrl + `/subscription/${subscriptionId}/mbb/offerings`;
    return this.http.get<MbbAllowedChangeInfo[]>(offeringUrl);
  }

  getAvailableSubscriptionServices(subscriptionId: string): Observable<AdditionalServiceSet> {
    const url = this.apiUrl + `/subscription/${subscriptionId}/additionalServices`;
    return this.http.get<AdditionalServiceSet>(url);
  }

  getAssignedSubscriptions(subscriptionIds: string[]): Observable<AssignedSubscriptionModel[]> {
    const assignedOfferingsUrl =
      this.apiUrl +
      `/subscription/existing/assigned-subscriptions?subscriptionIds=${subscriptionIds.join('&subscriptionIds=')}`;
    return this.http.get<AssignedSubscriptionModel[]>(assignedOfferingsUrl);
  }

  getSubscriptionCost(subscriptionId: number): Observable<SubscriptionCosts[]> {
    return this.http.get<SubscriptionCosts[]>(`${this.apiUrl}/subscription/${subscriptionId}/costs`);
  }

  getSubscriptionStatus(msisdn: number): Observable<SubscriptionDetailsSimplified> {
    return this.http.get<SubscriptionDetailsSimplified>(`${this.apiUrl}/subscription/${msisdn}/status`);
  }
}
